<template>
 <div class="shopping-cart">
     <hr/>
     <div v-if="product_info" class="margin-top-50 pretty-banner">
        <h5 style="font-size:18px;">Same product but different variations</h5>
        <p >if this product has different colours, sizes, etc... no need filling this long form again, go to this product view and set them.</p>
        <p class="center"><i class="fa fa-arrow-right"></i><a :href="product_url">Proceed to this Product's View </a></p>
     </div>
    <div v-if="!product_info" class="cart-ship-info register col-sm-10  contact_form">
        <div v-if="!product_subscription_active">
                
            <h6>Add Product / Service</h6>
                <form>
                    <ul class="">
                        <li class="col-sm-6 product-type">
                            <label> Product
                                <input class="sp-radio-btn" type="radio" v-model="is_product_service" value="product">
                            </label>
                        </li>
                        <li class="col-sm-6 product-type">
                        <label> Service
                                <input class="sp-radio-btn" type="radio" v-model="is_product_service" value="service">
                            </label>
                        </li>

                        <h6>{{is_product_service}} Information</h6>
                        <div style="margin-top:-3.6em">
                            <li class="col-sm-12">
                                <label> *Name
                                    <input type="text" v-model="product.product_name" value="" placeholder="">
                                </label>
                            </li>
                            
                            <li class="col-md-4" v-if="sellpoint_categories.length > 0">
                                <label> Select from My Shop Categories
                                <select v-model="product.product_category" id="category-type-1" v-on:change="trackevent('category-type-1')">
                                    <option value="0" :disabled="category_type_1">Select</option>
                                    <option :disabled="category_type_1" v-for="category in sellpoint_categories" :key="category.business_category_id" :value="category.business_category_id">{{category.business_category}}</option>
                                </select>
                                </label>
                            </li>
                        
                            <li class="col-md-4">
                                <label><span v-if="sellpoint_categories.length > 0"><b>Or </b></span> Select from Related Categories
                                <select v-model="main_category" @change="getSubCategories(main_category)">
                                    <option value="0">Select</option>
                                    <option v-for="category in categories" :key="category.category_id" :value="category">{{category.category_name}}</option>
                                </select>
                                </label>
                                <br>
                                <label v-if="sub_categories.length != 0"> Select a Category
                                <select v-model="product.product_sub_category" class="category-type-2" v-on:change="trackevent('category-type-2')">
                                    <option value="0" :disabled="category_type_2">Select</option>
                                    <option :disabled="category_type_2" v-for="category in sub_categories" :key="category.sub_category_id" :value="category.sub_category_id">{{category.sub_category_name}}</option>
                                </select>
                                </label>
                                <!-- DEPRAC <label><span v-if="sellpoint_categories.length > 0"><b>Or </b></span> Select from Shop Categories
                                <select v-model="product.product_sub_category" class="category-type-2" v-on:change="trackevent('category-type-2')">
                                    <option value="0" :disabled="category_type_2">Select</option>
                                    <option :disabled="category_type_2" v-for="category in sub_categories" :key="category.sub_category_id" :value="category.sub_category_id">{{category.sub_category_name}}</option>
                                </select>
                                </label> -->
                                
                            </li>
                        
                            <li class="col-md-4">
                                <label> <b>Or </b> Enter a specific Category
                                    <input :disabled="category_type_3" type="text" v-model="product.product_listed_category" placeholder="" id="category-type-3" v-on:change="trackevent('category-type-3')">
                                </label>
                            </li>
                            <li class="col-md-12">
                                <label> *Description
                                    <textarea  v-model="product.product_description"></textarea>
                                </label>
                            </li>
                            <!-- <h6>Add a product Item, you can add more items later</h6> -->
                            
                            <li class="col-md-4">
                                <label> *Price
                                    <input type="number" v-model="product.product_item_price" placeholder="" required>
                                </label>
                            </li>
                            <!-- <li class="col-md-12">
                                <label> More Information</label>
                            </li> -->

                            <li class="col-md-4" v-if="is_product_service == 'product'">
                                <label> *Weight(Kg)
                                    <input type="number" v-model="product.product_item_weight"  step="any" placeholder="" required>
                                </label>
                            </li>

                            <li class="col-md-4">
                                <label> *Quantity
                                    <input type="number" v-model="product.product_item_quantity"  placeholder="" required>
                                </label>
                            </li>
                            
                            <li class="col-md-12">
                                <p class="p-tiny-info">{{max_media_info}}</p>
                                <div class="upload-btn-wrapper" style="cursor:pointer">
                                    <!-- <img class="img_responsive"/> -->
                                    <button type="button" class="upload-btn">Add <span style="text-transform: capitalize;">{{is_product_service}}</span> Image / Video</button>
                                    <input type="file" id="input-file" @change="onFileChange($event)" accept="video/*,image/*" capture/>
                                    <span v-if="file_info[0]"><b>Added {{file_info[0].name}}</b></span>                                                                                                                                                                                                                                                                                                                                        
                                </div>
                                <p class="data-error-message">{{data_media_error_message}}</p>
                            </li>
                            <li class="col-md-12">
                                <p class="data-error-message">{{data_error_message}}</p>
                                <p class="data-success-message">{{data_success_message}}</p>
                                <div v-if="action_loading" class="loading-sm"></div>
                                <p class="p-tiny-descr" v-if="is_product_service == 'product'">
                                    Continue to set up product and add different product variant like colours and sizes
                                </p>
                                <p class="p-tiny-descr" v-if="is_product_service == 'service'">
                                    Continue to set up <b>service</b> and add different services details like, service packages, subscriptions and plans
                                </p>
                                <button :disabled="disable_btn" type="button" class="btn" @click="addProduct">Continue</button>
                            </li>
                        </div>
                    </ul>

                </form>
        </div>
        <div v-else>
            <h6>Add Subscription Plan</h6>
            <form>
                    <ul class="">
                        <div style="margin-top:-3.6em">
                            <li class="col-sm-12">
                                <label> *Plan Name
                                    <input type="text" v-model="product.product_name" value="" placeholder="">
                                </label>
                            </li>
                            <li class="col-sm-12">
                                <label> *Plan Description Name
                                    <input type="text" v-model="product.product_descr_name" value="" placeholder="">
                                </label>
                            </li>
                           
                            <li class="col-md-12">
                                <label> *Plan Details</label>
                                <label> 
                                    <input type="text" v-model="subscription_list[0]"  class="form-control">
                                </label>
                                <label> 
                                    <input type="text" v-model="subscription_list[1]"  class="form-control">
                                </label>
                                <label> 
                                    <input type="text" v-model="subscription_list[2]"  class="form-control">
                                </label>
                                <label> 
                                    <input type="text" v-model="subscription_list[3]" class="form-control">
                                </label>
                                <label> 
                                    <input type="text" v-model="subscription_list[4]"  class="form-control">
                                </label>
                                <label> 
                                    <input type="text" v-model="subscription_list[5]" class="form-control">
                                </label>
                            </li>

                            <li class="col-md-12" v-if="product_app_subscription_active">
                                <label> *Plan Limits</label>
                                <label> Products Limit
                                    <input type="number" v-model="product.product_service_app_products_limit"  class="form-control">
                                </label>
                                <label> Product Items Limit
                                    <input type="number" v-model="product.product_service_app_product_items_limit"  class="form-control">
                                </label>
                                <label> Posts Limit
                                    <input type="number" v-model="product.product_service_app_posts_limit"  class="form-control">
                                </label>
                                <label> Gallery Lookbook Limit
                                    <input type="number" v-model="product.product_service_app_gallery_limit"  class="form-control">
                                </label>
                                <label> Gallery Lookbook Posts Limit
                                    <input type="number" v-model="product.product_service_app_gallery_posts_limit"  class="form-control">
                                </label>
                                
                            </li>
                        
                             
                            
                            <li class="col-md-4">
                                <label> *Price
                                    <input type="number" v-model="product.product_item_price" placeholder="" required>
                                </label>
                            </li>
                             <li class="col-md-12">
                                <label> *Service Tag
                                    <input type="text" v-model="product.product_item_service_tag"  placeholder="" class="form-control">
                                </label>
                            </li>
                            <li class="col-md-12">
                                <label class="col-md-6"> *Subscription Duration
                                    <input type="number" v-model="product.product_item_service_duration"  placeholder="" class="form-control">
                                </label>
                                <select class="col-md-6 form-control" v-model="service_duration">
                                    <option>Select</option>
                                    <option value=" years">year(s)</option>
                                    <option value=" months">month(s)</option>
                                    <option value=" days">day(s)</option>
                                </select>
                            </li>
                        
                            <li class="col-md-12">
                                <p class="data-error-message">{{data_error_message}}</p>
                                <p class="data-success-message">{{data_success_message}}</p>
                                <div v-if="action_loading" class="loading-sm"></div>
                                <p class="p-tiny-descr" v-if="is_product_service == 'product'">
                                    Continue to set up product and add different product variant like colours and sizes
                                </p>
                                <p class="p-tiny-descr" v-if="is_product_service == 'service'">
                                    Continue to set up <b>service</b> and add different services details like, service packages, subscriptions and plans
                                </p>
                                <button :disabled="disable_btn" type="button" class="btn" @click="addProductSubscription">Continue</button>
                            </li>
                        </div>
                    </ul>

                </form>
        </div>
    </div>
</div>
</template>
<style>
.pretty-banner{
   border: 1px solid #b3b9c0;
   padding: 1.2em;
   background: #83ee91;
   line-height: 1.8;
   border-radius: 5px;
   color:#fff; 
}
.pretty-banner p a:hover{
    color: #ff0000;
}
  /*form*/
  .contact_form li {
	text-align: left;
	margin-bottom: 10px;
}
.contact_form li input {
	display: inline-block;
	width: 100%;
	height: 35px;
	padding: 0 10px;
	margin-top: 5px;
}
.contact_form li .error {
	border: 1px solid #CCC;
	border-bottom: 1px solid red;
}
.contact_form li .form-control {
	height: 45px;
	border: 1px solid #2d3a4b;
	box-shadow: none;
	border-radius: 0px;
	background: #fff;
}
.contact_form li textarea {
	height: 140px !important;
	width: 340px;
	margin-top: 10px;
}
.contact_form li .btn {
	text-transform: uppercase;
	padding: 0px 40px;
	height: 45px;
	line-height: 45px;
	font-size: 14px;
	margin-top: 15px;
}
.contact_form li .btn:hover {
	background: #ffffff;
}
.contact-form .tittle {
	text-align: center;
}
.contact-form .tittle hr {
	width: 28px;
	height: 5px;
	margin: 15px auto;
	background: #448aff;
	border: none;
}
.contact-form .tittle p {
	text-transform: none;
	font-size: 16px;
}
.contact-form label {
	font-weight: normal;
	color: #2d3a4b;
	font-size: 12px;
	text-transform: uppercase;
	display: inline-block;
	width: 100%;
	margin: 0px;
	margin-bottom: 13px;
}
.contact-form textarea {
	display: inline-block;
	width: 100%;
	position: relative;
	padding: 10px 20px;
}
.sp-radio-btn{
    width:12%;
    height: 12%;
    background: #2d3a4b;
  }
</style>

<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'ProductForm',
    data () {
        return {
            user:{},
            sellpoint: {},
            sellpoint_categories: {},
            categories:{},
            main_category:{},
            sub_categories: [],
            product:{},
            product_item: {},
            service_duration:"",
            is_product_service: "product",
            disable_btn: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {},
            action_loading:false,
            data_error_message:"",
            data_success_message:"",
            data_media_error_message:"",
            max_media_info:service.max_upload_image_info,
            product_subscription_active:false,
            product_app_subscription_active:false,
            product_app_subscription:0,
            product_subscription_group:0,
            product_subscription_category:"",
            subscription_list:[],

        }
    },
    components: {
       
     },
    methods: {
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },
        setComponent(attr1,attr2){
            this.setPanel = true;
            if(attr1 == 'create-sellpoint'){
                this.createSellpointPanel= true;
                this.addProductPanel = false;
                this.addProductItemPanel = false;
            }
            if(attr1 == 'add-product'){
                this.addProductPanel = true;
                this.addProductItemPanel = false;
                this.createSellpointPanel= false;
            }
            if(attr1 == 'add-product-item'){
                this.addProductItemPanel = true;
                this.addProductPanel = false;
                this.createSellpointPanel= false;

            }
        },
        
        trackevent(e){
            // $('#category-type-3').disabled = true;
            if(e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined){
              this.category_type_2 = true;
              this.category_type_3 = true;
            }
            else if(e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined){
              this.category_type_1 = true;
              this.category_type_3 = true;
            }
            else if(e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined){
              this.category_type_1 = true;
              this.category_type_2 = true; 
            }
            else{
            this.category_type_1 = false;
              this.category_type_2 = false;
              this.category_type_3 = false;
             }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        //get sellpoint categories
                        this.getSellpointCategories();

                    }else {
                        this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
        },

        getSellpointCategories(){
            service.getBusinessByUserName(this, this.$route.params.id).then(response => {
                if(response.body.status == 200) {
                   this.sellpoint = response.body.data;
                   //let sellpoint_data = response.body.data;
                    service.getBusinessCategories(this, this.sellpoint.business_id).then(response => {
                        if(response.body.status == 200) {
                            this.sellpoint_categories = response.body.data;
                        }
                    }).catch((err) => {})
                    // this.getSubCategories(this.sellpoint.business_category_id);
                    this.getCategories(this.sellpoint.business_category_id);
                }
            }).catch((err) => {
                //log it
               // this.$router.push("/")
            //    console.log(err)
            })

        },

        //DEPRAC

        // getSubCategories(category){
        //     service.getBusinessSubCategories(this, category).then(response => {
        //         if(response.body.status == 200) {
        //             this.sub_categories = response.body.data;
        //         }
        //     }).catch((err) => {})
                
        // },

        getCategories(category){
            service.getMainCategories(this, category).then(response => {
               if(response.body.status == 200) {
                    this.categories = response.body.data;
                }
            }).catch((err) => {})
                
        },

        getSubCategories(category){
            if(category != undefined){
                this.sub_categories = category.sub_categories;
            }else{
                this.sub_categories = [];
            }
            
        },

        addProductSubscription(){
            this.is_product_service = "service";
            this.product.product_listed_category = this.product_subscription_category;
            this.product.product_group_name = this.product_subscription_category;
            this.product.product_is_subscribed_to = this.product_subscription_group;
            this.product.product_is_subscribed_to_app = this.product_app_subscription;
            //then call add product
            this.addProduct();
        },

        addProduct(){
            this.activate_processing();
            // this.disable_btn = true;
            //this.business.agree = true;
            var credentials = {
                product_name: this.product.product_name,
                product_is_product_or_service: this.is_product_service,
                product_category: this.product.product_category || 0,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                product_business: this.sellpoint.business_id,
                product_description: this.product.product_description || "nill",
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1,
                product_group_name: this.product.product_group_name || "nill",

                //new--for subscriptions
                product_description_name: this.product.product_descr_name || "nill",
                product_is_subscribed_to: this.product.product_is_subscribed_to || 0,
                product_is_subscribed_to_app: this.product.product_is_subscribed_to_app || 0,
                product_subscription_details: this.subscription_list,
                product_item_service_tag: this.product.product_item_service_tag || "Nill",
                product_item_service_duration: (this.product.product_item_service_duration + this.service_duration) || '1 year',
                //limits
                product_service_app_products_limit: this.product.product_service_app_product_limit || 0,
                product_service_app_product_items_limit: this.product.product_service_app_product_items_limit || 0,
                product_service_app_posts_limit: this.product.product_service_app_posts_limit || 0,
                product_service_app_gallery_limit: this.product.product_service_app_gallery_limit || 0,
                product_service_app_gallery_posts_limit: this.product.product_service_app_gallery_posts_limit || 0,
                //..../subscriptions
            }
            
            let navi = this.$router;
            if(credentials.product_name != undefined || credentials.product_name != '') {
                service.addProduct(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        toastr.success("Product Added Successfully", 'Success!');
                        this.data_success_message =  "Product Added Successfully";
                    
                        //log user in
                        this.product = data.body.data;
                        //add image
                        //let result = data.body.data;
                        let url = "/"+this.$route.params.id+"/"+this.product.product_url_name+"?setup=yes";

                        if(!this.product_subscription_active){ ///not for subscription for now
                        // this.imageForm.append("data_id", this.product.product_item_id); //refac
                        this.imageForm.append("data_id", this.product.product_id);
                        // this.imageForm.append("data_type","product_items"); //refac
                        this.imageForm.append("data_type","products");
                        service.uploadDataPhoto(this, this.imageForm).then(data => {
                        if(data.body.status == 200){
                            //this.product.product_image = data.body.data;
                            // location.reload(true);
                            // this.product_info = true;
                            
                            location.replace(url);
                        }
                        }).catch((err) => {
                                if(err) {
                                // log it
                                }
                            // toastr.warning("Something went wrong.", 'Warning!');
                            
                        })
                        //if uploading takes time continue with reload
                        this.data_media_error_message = service.media_upload_timeout_msg;
                        let self = this;
                        setTimeout(function(){  self.data_media_error_message; }, 1200); //wait for 1min and timeout
                        setTimeout(function(){  location.replace(url); }, 2000); //wait for 1min and timeout
                        }else{
                            location.replace(url);
                        }
                        //navi.push("/"+this.$route.params.id+"/"+this.product.product_url_name); //changed for now, info on banner

                        
                    }
                }).catch((err) => {
                    if(err) { 
                        toastr.warning("Something went wrong", 'Warning!'); 
                    //    console.log(err)
                        this.data_error_message =  "Something went wrong";
                       this.deactivate_processing();
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.data_error_message =  "Kindly fill all fields";
                this.deactivate_processing();
                // this.disable_btn = false;
            }
        },

        
    // addProductItem(){
    //     this.disable_btn = true;
    //     //this.business.agree = true;
    //     var credentials = {
    //         product_id: this.product.product_id,
    //         product_price: this.product_item.product_item_price,
    //     }

    //     let navi = this.$router;
    //    if(credentials.product_price != undefined) {
    //         service.addProductItem(this, credentials).then(function(data) {
    //             if(data.body.status == 201) {
    //                 toastr.success("Product Item Added Successfully", 'Success!');
    //                 //log user in
    //                 this.setComponent('add-product-item','');
    //             }
    //         }).catch((err) => {
    //             if(err) {
    //                 toastr.warning("Something went wrong", 'Warning!'); 
    //                 //console.log(err)
    //                 this.disable_btn = false;
    //             }
    //         })
    //     }else {
    //         toastr.error('Kindly fill all fields', 'Warning!');
    //         this.disable_btn = false;
    //     }
    // },

    //uploads
    onFileChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (files.length)
        {   
            this.file_info = files;
            let formData = new FormData();
            formData.append('photo', files[0]); 
            this.imageForm = formData;
        }   
       
    },

},
    created: function(){
        if(localStorage.getItem("sp-subscription") == 'active'){
            this.product_subscription_active = true;
            this.product_subscription_group = localStorage.getItem("sp-subscription-active");
            this.product_subscription_category = localStorage.getItem("sp-subscription-group");

            //for app-subscrip
            if(localStorage.getItem("sp-app-subscription-active") == 'active'){
                this.product_app_subscription_active = true;
                this.product_app_subscription = localStorage.getItem("sp-app-subscription");
            }
        }
       
        this.preset();
    }
}

</script>


// WEBPACK FOOTER //
// ProductForm.vue?7b417c69